module.exports = __webpack_public_path__ + "img/marheader.8d171645.png";